import { render, staticRenderFns } from "./TaskCenterDetail.vue?vue&type=template&id=6fdfabe8&scoped=true&"
import script from "./TaskCenterDetail.vue?vue&type=script&lang=js&"
export * from "./TaskCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./TaskCenterDetail.vue?vue&type=style&index=0&id=6fdfabe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdfabe8",
  null
  
)

export default component.exports